import {scaleLinear} from 'd3-scale';
import {isValid} from 'validators/number-validator';

const _isValid = (values) => {
  if (values && values.length > 1) {
    for (let ii = 0, nn = values.length; ii < nn; ii++) {
      if (typeof values[ii] === 'string') {
        return true;
      }
      if (!isValid(values[ii])) {
        return false;
      }
    }
    return true;
  }
};

export default (domain, range) => {
  if (_isValid(domain) && _isValid(range)) {
    return scaleLinear().domain(domain).range(range);
  }
};
